(function($){
  $(function(){
    $(document).ready(function() {
      var showTour = SHOW_TOUR;

      if (showTour) {
        // intro.js tour steps
        var steps = introJs();
        steps.setOptions({
          initialStep: 0,
          showBullets: false,
          showProgress: true,
          hidePrev: true,
          hideNext: true,
          exitOnEsc: false,
          exitOnOverlayClick: false,
          keyboardNavigation: true,
          scrollToElement: true,
          scrollPadding: 0,
          steps: [
            {
              element: '.ace_editor',
              intro: `Use the editor to write your code. Select between Python 3 and Python 2.`
            },
            {
              element: '.js-assignment-try-code-button',
              intro: `To try things out, you can just "Run code". The output will be displayed
              in the console above.`,
              position: 'left'
            },
            {
              element: $('.assignment-test-cases')[1],
              intro: `Tests let you check your code actually works as expected.
              <a href="https://en.wikipedia.org/wiki/Test-driven_development">TDD</a> is <b>extremely important</b> in
              Software Development.`
            },
            {
              element: '.js-assignment-submit-code-button',
              intro: `Once you're done you can click here to <b>save</b> your solution and
              mark this lesson as <b>finished</b>`,
              position: 'left'
            }
          ]
        });
        steps.onexit(function(){
          $(".assignment-description").animate({ scrollTop: 0 }, "slow");
        })
        steps.start();

        // intro.js tour hints
        var hints = introJs();
        hints.setOptions({
          hints: [
            {
              hint: `Don't forget to submit your solution when you're done.
              <b>This will keep your progress updated</b>`,
              element: $('.js-assignment-submit-code-button')[0],
              hintPosition: 'middle-right'
            }
          ]
        });
        hints.addHints();

        // simulate hint on first try test button
        var a = $('.js-assignment-try-test-button');
        a.addClass('highlight');

        // show start tour button
        var startTourButton = $('.info-button');
        startTourButton.removeClass('hidden');
        startTourButton.on('click', function() {
          steps.start();
        });
      };
    });
  }); // end of document ready
})(jQuery); // end of jQuery name space
